export default "__VITE_ASSET__w7bYkN4b__"